import React, { useEffect, useState } from 'react';
import './RedCactus.scss';
import useMasterData from '../../hooks/useMasterData';
import SettingService from '../../services/setting.service';

const RedCactus: React.FC = () => {
  const masterData = useMasterData();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isRedCactusEnabled, setIsRedCactusEnabled] = useState<boolean>(false);
  const [isRedCactusEnabledInstanceLevel, setIsRedCactusEnabledInstanceLevel] = useState<boolean>(false);
  const [isIconVisible, setIsIconVisible] = useState(true);

  const hideIcon = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsIconVisible(false);
    setIsOpen(false);
  };

  const showIcon = () => {
    setIsIconVisible(true);
  };

  useEffect(() => {
    if(masterData?.isRedCactusActive){
      setIsRedCactusEnabled(true);
    } else {
      setIsRedCactusEnabled(false);
    }
  }, [masterData?.isRedCactusActive]);

  useEffect(() => {
    const getInstanceLevelEnabled = async () => {
      const instanceEnabled = await SettingService.getRedCactusIsEnabled();

      if(instanceEnabled.toLocaleLowerCase() === "true"){
        setIsRedCactusEnabledInstanceLevel(true);
      } else {
        setIsRedCactusEnabledInstanceLevel(false);
      }      
    };
    
    getInstanceLevelEnabled();
  }, []);

  const toggleBubble = () => {
    setIsOpen(!isOpen);
  };

  return (
    (isRedCactusEnabledInstanceLevel && isRedCactusEnabled) ? (
      <>
        {isIconVisible ? (
          <>
            <button className="floating-button" onClick={toggleBubble}>
              <span className="close-icon" onClick={hideIcon}>-</span>
              <img
                src={require("../../assets/images/icon.png")}
                alt="RedCactus Icon"
              />
            </button>
            {isOpen && (
              <div className="iframe-bubble">
                <iframe src="https://eu.bubble365.app" title="RedCactus Bubble" />
              </div>
            )}
          </>
        ) : (
          <button className="restore-button" onClick={showIcon} title="RedCactus">
            <img
              src={require("../../assets/images/icon.png")}
              alt="Show RedCactus"
              className="restore-icon"
            />
          </button>
        )}
      </>
    ) : null
  );
};

export default RedCactus;